<template>
  <pagelayout :contentBgcolor="isDark && '#eeeeee'">
    <appbar :title="`11选5${app_my_config.lotteryPurchase.name}说明`" />
    <div class="guide">
      <div class="tit">三码</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">前三直选复式</td>
            <td>从01-11共11个号码中选择3个不重复的号码组成一注，所选号码与当期顺序摇出的5个号码中的前3个号码相同，且顺序一致，即为中奖。</td>
          </tr>
          <tr>
            <td>如：第一位选择01，第二位选择02，第三位选择03，开奖号码顺序为01，02，03 * *，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">前三直选单式</td>
            <td>手动输入3个号码组成一注，所输入的号码与当期顺序摇出的5个号码中的前3个号码相同，且顺序一致，即为中奖。</td>
          </tr>
          <tr>
            <td>如：手动输入01 02 03，开奖号码为是01 02 03 * *，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <table width="100%" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td rowspan="2" class="tit">前三组选复式</td>
                <td>从01-11中共11个号码中选择3个号码，所选号码与当期顺序摇出的5个号码中的前3个号码相同，顺序不限，即为中奖。</td>
              </tr>
              <tr>
                <td>&nbsp; 如：选择01 02 03（展开为01 02 03 * *，01 03 02 * *，02 01 03 * *，02 03 01 * *，03 01 02 * *，03 02 01 *
                  *），开奖号码为03 01 02，即为中奖。</td>
              </tr>
            </tbody>
          </table>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">前三组选单式</td>
            <td>手动输入3个号码组成一注，所输入的号码与当期顺序摇出的5个号码中的前3个号码相同，顺序不限，即为中奖。</td>
          </tr>
          <tr>
            <td>如：手动输入01 02 03（展开为01 02 03 * *，01 03 02 * * , 02 01 03 * *，02 03 01 * *，03 01 02 * *，03 02 01 * *），开奖号码为01
              03 02 * *，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <div class="tit">二码</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">前二直选复式</td>
            <td>从01-11共11个号码中选择2个不重复的号码组成一注，所选号码与当期顺序摇出的5个号码中的前2个号码相同，且顺序一致，即中奖。</td>
          </tr>
          <tr>
            <td>如：第一位选择01，第二位选择02，开奖号码 01 02 * * *，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">前二直选单式</td>
            <td>手动输入2个号码组成一注，所输入的号码与当期顺序摇出的5个号码中的前2个号码相同，且顺序一致，即为中奖。</td>
          </tr>
          <tr>
            <td>如：手动输入 01 02，开奖号码为01 02 * * *，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">前二组选复式</td>
            <td>从01-11中共11个号码中选择2个号码，所选号码与当期顺序摇出的5个号码中的前2个号码相同，顺序不限，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择01 02（展开为01 02 * * *，02 01 * * *），开奖号码为02 01 * * * 或 01 02 * * *，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">前二组选单式</td>
            <td>手动输入2个号码组成一注，所输入的号码与当期顺序摇出的5个号码中的前2个号码相同，顺序不限，即为中奖。</td>
          </tr>
          <tr>
            <td>如：手动输入01 02（展开为01 02 * * *，02 01 * * *），开奖号码为02 01 *** 或 01 02 ***，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <div class="tit">不定位</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">前三不定位</td>
            <td>从01-11中共11个号码中选择1个号码，每注由1个号码组成，只要当期顺序摇出的第一位、第二位、第三位开奖号码中包含所选号码，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择01，开奖号码为01 * * * *，* 01 * * *，* * 01 * *，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <div class="tit">定位胆</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">第1-5位</td>
            <td>从第1-5位任意1个位置或多个位置上选择1个号码，所选号码与相同位置上的开奖号码一致，即为中奖。</td>
          </tr>
          <tr>
            <td>如：第一位选择01，开奖号码为01 * * * *，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <div class="tit">趣味性</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">定单双</td>
            <td>从5种单双个数组合中选择1种组合，当期开奖号码的单双个数与所选单双组合一致，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择5单0双，开奖号码01，03，05，07，09五个单数，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">猜中位</td>
            <td>从3-9中选择1个号码进行购买，所选号码与5个开奖号码按照大小顺序排列后的第3个号码相同，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择8，开奖号码为11，04，09，05，08，按开奖号码的数字大小排列为04，05，08，09，11，中间数08，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <div class="tit">任选</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">任选一中一</td>
            <td>从01-11共11个号码中选择1个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择05，开奖号码为08 04 11 05 03，即为中奖</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">任选二中二</td>
            <td>从01-11共11个号码中选择2个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择05 04，开奖号码为08 04 11 05 03，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">任选三中三</td>
            <td>从01-11共11个号码中选择3个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择05 04 11，开奖号码为08 04 11 05 03，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">任选四中四</td>
            <td>从01-11共11个号码中选择4个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择05 04 08 03，开奖号码为08 04 11 05 03，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">任选五中五</td>
            <td>从01-11共11个号码中选择5个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择05 04 11 03 08，开奖号码为08 04 11 05 03，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">任选六中五</td>
            <td>从01-11共11个号码中选择6个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择05 10 04 11 03 08，开奖号码为08 04 11 05 03，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">任选七中五</td>
            <td>从01-11共11个号码中选择7个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择05 04 10 11 03 08 09，开奖号码为08 04 11 05 03，即为中奖。</td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">任选八中五</td>
            <td>从01-11共11个号码中选择8个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
          </tr>
          <tr>
            <td>如：选择05 04 11 03 08 10 09 01，开奖号码为08 04 11 05 03，即为中奖。</td>
          </tr>
        </tbody>
      </table>
    </div>
  </pagelayout>
</template>

<script>
import appConfigMixins from "@c/mixins/appConfig.mixins";
export default {
  mixins: [appConfigMixins],
};
</script>

<style lang="scss">
@import "~/assets/common/page/guide.scss";
</style>
